import React, { useState, useEffect, useCallback } from 'react';
import GoogleMapReact from 'google-map-react';
import { useHistory } from 'react-router-dom';
import useApi from '../../api/useApi';
import '../../scrollbar.css';
import ShowZone from '../../components/ShowZone';

function Table() {
  const user = localStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = user && JSON.parse(localStorage.user).organization.id;
  const [openCreate, setOpenCreate] = useState(false);
  const [{ isLoading, isError, data }] = useApi();
  const [zones, zoneData] = useApi();
  const [zone, setzone] = useState([]);
  const [openZone, setOpenZone] = useState(false);
  const [id, setId] = useState(null);
  const history = useHistory();
  const [center, setCenter] = useState({
    lat: 32.874525,
    lng: -117.2160221,
  });
  const [coordinates, setCoordinates] = useState([center]);
  const [cor, setCor] = useState([]);
  
  useEffect(() => {
    user && zoneData(`/organization/${orgId}/zones`, 'GET');
  }, []);

  useEffect(() => {
    if (!zones.isLoading && !zones.isError && zones.data) {
      const zonesFiltered = zones.data.filter((zone) => zone.location !== null);
      const _zones = zonesFiltered.sort((a, b) => (a.location.toLowerCase() > b.location.toLowerCase() ? 1 : -1));
      setzone(_zones);
      for (let i = 0; i < _zones.length; i++) {
        if (_zones[i].gateways.length > 0) {
          cor.push({
            lat: parseFloat(_zones[i].gateways[0].latitude),
            lng: parseFloat(_zones[i].gateways[0].longitude),
          });
        }
      }
      setCoordinates(cor);
    }
  }, [zones.isLoading, zones.isError, zones.data]);

  const getMapOptions = (maps) => {
    return {
      streetViewControl: false,
      scaleControl: true,
      fullscreenControl: true,
      gestureHandling: 'greedy',
      disableDoubleClickZoom: true,
      minZoom: 5,
      maxZoom: 18,

      mapTypeControl: true,
      // mapTypeId: maps.MapTypeId.ROADMAP,
      mapTypeControlOptions: {
        style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: maps.ControlPosition.BOTTOM_CENTER,
        mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE, maps.MapTypeId.HYBRID],
      },

      zoomControl: true,
      clickableIcons: true,
    };
  };

  const handlegoogleApi = (map, maps, places) => {
    const markers = [];
    places.forEach((place, idx) => {
      const svgMarker = {
        path:
          'm12 0c-4.4183 2.3685e-15 -8 3.5817-8 8 0 1.421 0.3816 2.75 1.0312 3.906 0.1079 0.192 0.221 0.381 0.3438 0.563l6.625 11.531 6.625-11.531c0.102-0.151 0.19-0.311 0.281-0.469l0.063-0.094c0.649-1.156 1.031-2.485 1.031-3.906 0-4.4183-3.582-8-8-8zm0 4c2.209 0 4 1.7909 4 4 0 2.209-1.791 4-4 4-2.2091 0-4-1.791-4-4 0-2.2091 1.7909-4 4-4z',
        fillColor: 'red',
        fillOpacity: 1,
        strokeWeight: 0,
        rotation: 0,
        scale: 1,
        anchor: new maps.Point(15, 30),
      };
      markers.push(
        new maps.Marker({
          position: {
            lat: place.lat,
            lng: place.lng,
          },
          icon: svgMarker,
          map,
          title: `(${zone[idx]?.location}, ${place.lat}, ${place.lng})`,
        })
      );
    });

    // const markerCluster = new MarkerClusterer(map, markers, {
    //   imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
    //   gridSize: 20,
    //   minimumClusterSize: 5,
    // });

    // const symbolOne = {
    //   path: 'M -2,0 0,-2 2,0 0,2 z',
    //   strokeColor: '#F00',
    //   fillColor: '#F00',
    //   fillOpacity: 1,
    // };

    // const symbolThree = {
    //   path: 'M -2,-2 2,2 M 2,-2 -2,2',
    //   strokeColor: '#292',
    //   strokeWeight: 1,
    // };

    // const symbolTwo = {
    //   path: maps.SymbolPath.FORWARD_CLOSED_ARROW,
    //   scale: 2,
    //   scaledSize: new maps.Size(100, 100),
    //   origin: new maps.Point(0, 0), // origin
    //   anchor: new maps.Point(0, 0), // anchor
    //   strokeColor: 'red',
    //   // rotation: 45,
    // };

    // const routePolyline = new maps.Polyline({
    //   path: places,
    //   icons: [
    //     {
    //       icon: symbolOne,
    //       offset: '0%',
    //     },
    //     {
    //       icon: symbolTwo,
    //       offset: '50%',
    //     },
    //     {
    //       icon: symbolThree,
    //       offset: '100%',
    //     },
    //   ],
    //   strokeColor: '#00CCFF',
    //   strokeWidth: 1,
    //   strokeWeight: 1,
    // });
    // routePolyline.setMap(map);
  };

  const toggleOpenZone = (prev) => {
    setOpenZone((prev) => !prev);
  };

  return (
    <>
      {
        <div
          className="h-full w-topBar fixed hideScroll"
          style={{ filter: openCreate && 'blur(2px)', left: '12%', width: '88%', overflow: 'auto' }}
        >
          <div className="z-50" style={{ height: '12vh', background: '#f9f9f9', paddingBottom: '4vh' }}>
            <div
              className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
              style={{ paddingTop: '4vh' }}
            >
              <span className="text-textBlue1 font-bold text-xl">Zones</span>
              {openZone && <button
                className="mt-1 lg:mt-0 w-28 lg:w-max border px-3 py-1 absolute rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center right-56 items-center h-8 bg-btnBg text-white relative rounded-md"
                onClick={(e) => {
                  setOpenZone(false);
                }}
              >
                Show Map
              </button>}
            </div>
          </div>
          <div className="flex">
            <div className="h-screen w-1/4">
              {!isLoading ? (
                <div className="exampleZones bg-tableBg fixed h-screen">
                  <h1 className="text-lg font-bold text-center bg-white p-2">List of Zones</h1>
                  <div
                    className="pb-1 border hideScroll"
                    style={{ borderColor: '#e6e6e6', height: '77vh', overflow: 'auto', borderBottom: 'none' }}
                  >
                    {zone.map((item, idx) => (
                      <div
                        className="m-2.5 px-4 bg-white flex rounded-md
                  shadow-sm relative border-2 border-transparent hover:border-indigo-200 focus-within:border-indigo-200"
                      >
                        <div className=" py-2 text-sm w-full px-10">
                          Zone:
                          <a
                            href="#"
                            style={{ color: 'blue' }}
                            onClick={(e) => {
                              setId(e.target.id);
                              setOpenZone(true);
                            }}
                            id={idx}
                          >
                            {` ${item.location !== null ? item.location : 'undefined'}`}
                          </a>
                          <p>{`Latitude : ${item.gateways[0].latitude}`}</p>
                          <p>{`Longitude : ${item.gateways[0].longitude}`}</p>
                        </div>
                        {/* <div className=" py-2 text-sm w-36 px-10">
                            {item.gateways[0].latitude}
                          </div>
                          <div className=" py-2 text-sm w-36 px-10">
                            {item.gateways[0].longitude}
                          </div> */}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
              )}
            </div>

            <div className="w-3/4 h-screen" style={{ height: '88vh' }}>
              {!openZone ? (
                <GoogleMapReact
                  key={coordinates}
                  bootstrapURLKeys={{ key: 'AIzaSyDVsc9GqAbD6BF7vKPaLTNgtFFksrxj0Yw' }}
                  options={getMapOptions}
                  defaultZoom={8}
                  defaultCenter={center}
                  onGoogleApiLoaded={({ map, maps }) => handlegoogleApi(map, maps, coordinates)}
                />
              ) : (
                <div className="w-full">{openZone && <ShowZone gatewayData={zone[id]} />}</div>
              )}
            </div>
          </div>
        </div>
      }
    </>
  );
}

export default Table;
